import { Injectable } from '@angular/core';
import { SecurityDto } from '../dtos/security-dto.model';
import { ApiService } from './api.service';
import { RoleDto } from '../dtos/role-dto.model';
import { RoleResourceDto } from '../dtos/role-resource-dto.model';
import { Router } from '@angular/router';
import { SecurityUserDto } from '../dtos/security-user-dto.model';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {
  security: SecurityDto = new SecurityDto();

  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router
  ) { }

  getMyMSId(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);

    if (currentUser?.profile?.identity_provider === 'uhg-ms-id') {
      return currentUser?.profile?.preferred_username?.split('_')[0] ?? 'Unknown';
    } else {
      return currentUser?.profile?.identity_provider_identity?.replace('oma-', '').replace("_oma", "") ?? 'Unknown';
    }
  }

  async getUserBasedOnUserId(apiUrl: string, userId: string): Promise<SecurityUserDto> {
    const result = await this.apiService.get<SecurityUserDto>('', `${apiUrl}/authorization/userbasedonuserid/${userId}`);
    return result ?? new SecurityUserDto();
  }

  async getRoleBasedOnUserId(apiUrl: string, userId: string): Promise<RoleDto> {
    return await this.apiService.get<RoleDto>('Getting role information', `${apiUrl}/authorization/rolebasedonuserid/${userId}`) ?? new RoleDto();
  }

  async getSecurity(authorizationUrl: string, myMSId: string): Promise<SecurityDto | null> {
    return await this.apiService.get<SecurityDto>('', `${authorizationUrl}/Authorization/getsecuritylegacy/${myMSId}`);
  }

  async getRoles(apiUrl: string): Promise<RoleDto[]> {
    const response = await this.apiService.get<RoleDto[]>('', `${apiUrl}/authorization/roles`);
    return response ?? [];
  }

  async getRoleResources(apiUrl: string, role: string): Promise<RoleResourceDto[]> {
    const response = await this.apiService.get<RoleResourceDto[]>('', `${apiUrl}/authorization/roleResources/${role}`);
    return response ?? [];
  }

  async getResources(apiUrl: string, loggedInUser: string): Promise<string[]> {
    const response = await this.apiService.get<string[]>('', `${apiUrl}/Authorization/GetResources/${loggedInUser}`);
    return response ?? [];
  }

  async getAuthorization(apiUrl: string): Promise<void> {
  const currentUser = JSON.parse(localStorage.getItem('currentUser') as any);

  if (currentUser != null) {
    const loggedInUser = this.getMyMSId();
    
    // Check if impersonating - if yes, skip this entire method
    const isImpersonated = localStorage.getItem('IsImpersonated') === 'true';
    if (isImpersonated) {
      console.log('Impersonation active, skipping getAuthorization');
      return;
    }

    const data = await this.getRoleBasedOnUserId(apiUrl, loggedInUser)
    if (data) {
      if ((data !== null || data !== undefined) && data?.role !== null) {
        let roleName = data.role;

        const data2 = await this.getRoleResources(apiUrl, roleName);
        if (data2) {
          let resources: string[] = [];
          for (let i = 0; i < data2.length; i++) {
            resources.push(data2[i].resource.toLowerCase());
          }
          localStorage.setItem('resources', JSON.stringify(resources));
        }
      }
      else {
        const data3 = await this.getResources(apiUrl, loggedInUser);
        
        if (data3) {
          localStorage.setItem('resources', JSON.stringify(data3));
        }
      }
    }
  }
}

  getAccessToken(): string {
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      return JSON.parse(currentUser).access_token;
    }
    return '';
  }
}